import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Leaf, Globe, ChevronDown } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { useScreenInit } from '../../useScreenInit';
export function Welcome() {
  useScreenInit();
  const navigate = useNavigate();
  return <div className="min-h-screen flex flex-col bg-white px-6 py-10" data-id="element-232">
      {/* Language selector - top right, understated */}
      <div className="flex justify-end" data-id="element-233">
        <button className="flex items-center gap-1.5 text-sm font-medium text-text-secondary hover:text-text-primary transition-colors px-3 py-2 rounded-xl hover:bg-gray-50" data-id="element-234">
          <Globe className="w-4 h-4" data-id="element-235" />
          English
          <ChevronDown className="w-4 h-4" data-id="element-236" />
        </button>
      </div>

      {/* Brand + value prop - centered, lots of whitespace */}
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} className="flex-1 flex flex-col items-center justify-center text-center" data-id="element-237">
        <div className="w-16 h-16 bg-brand-primary rounded-2xl flex items-center justify-center mb-8" data-id="element-238">
          <Leaf className="w-8 h-8 text-white" data-id="element-239" />
        </div>
        <h1 className="text-3xl font-heading font-bold text-text-primary mb-3 leading-tight" data-id="element-240">
          Welcome to
          <br data-id="element-241" />
          FortuneBridge
        </h1>
        <p className="text-text-secondary text-base max-w-[280px] leading-relaxed" data-id="element-242">
          Building bridges out of poverty — together.
        </p>
      </motion.div>

      {/* Actions - clear primary + secondary */}
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.1,
      ease: 'easeOut'
    }} className="flex flex-col gap-3" data-id="element-243">
        <Button fullWidth size="lg" onClick={() => navigate('/select-user-type')} data-id="element-244">
          Create an Account
        </Button>
        <Button fullWidth size="lg" variant="ghost" onClick={() => navigate('/login')} data-id="element-245">
          I already have an account
        </Button>
      </motion.div>
    </div>;
}